export const getAllPromptsListConfig = () => ({
  url: `/get_all_prompts`,
});

export const addPromptConfig = () => ({
  url: `/prompt`,
});

export const getLLmVersionsConfig = () => ({
  url: `/llm_versions`,
});

export const getPromptByIdConfig = (prompt_id) => ({
  url: `/prompt/${prompt_id}`,
});

export const editPromptConfig = (prompt_id) => ({
  url: `/prompt/${prompt_id}`,
});

export const deletePromptConfig = (prompt_id) => ({
  url: `/delete_prompt/${prompt_id}`,
});

export const getAllPromptScreensConfig = () => ({
  url: `/prompt_screens`,
});

export const getAllConditionPromptConfig = () => ({
  url: `/condition_prompt`,
});

export const getAllPromptScreenConditionConfig = () => ({
  url: `/get_conditions_prompt`,
});

export const getFilterPromptConfig = () => ({
  url: `/filter_prompt`,
});
